import itemsSubcategory from './category/itemsSubcategory';

// Sajt je samo na srpskom: parametar `lang` se zadržava zbog postojećih poziva, ali se ne koristi.
export default class TitleTable{
    static convert(description, item, lang){
       return this.srTitle(description, item)
    }
    static srTitle(description, item){
        if(description.includes('mesec')){
            let res = description.split('mesec')[1].split('do')[0].split('-').join(' ') + 'do ' + description.split('do')[1].split('-')[1].split('-').join(' ');
            let subcategories = itemsSubcategory.subcategory.filter(x=> x.value == item);

           if(subcategories.length == 0 ) return null

            return  subcategories[0].description + ' za mesec ' + res;
        }

        return null
    }
}
